import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Home } from './pages/Home';
import { ScrollToTop } from './components/ScrollToTop';
// Services
import { HealthcareInsurance } from './pages/services/HealthcareInsurance';
import { BenefitsReview } from './pages/services/BenefitsReview';
import { WorkersComp } from './pages/services/WorkersComp';
// Coverage
import { Medicare } from './pages/coverage/Medicare';
import { IndividualFamilyHealth } from './pages/coverage/IndividualFamilyHealth';
import { LifeInsurance } from './pages/coverage/LifeInsurance';
import { DentalVision } from './pages/coverage/DentalVision';
import { Disability } from './pages/coverage/Disability';
import { TravelMedical } from './pages/coverage/TravelMedical';
import { EmployerGroup } from './pages/coverage/EmployerGroup';
export function App() {
  return <Router data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen flex flex-col bg-white font-sans text-slate-900 selection:bg-accent/30 selection:text-navy-dark" data-id="element-2">
        <Header data-id="element-3" />
        <div className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />

            {/* Services */}
            <Route path="/services/healthcare" element={<HealthcareInsurance data-id="element-9" />} data-id="element-8" />
            <Route path="/services/benefits-review" element={<BenefitsReview data-id="element-11" />} data-id="element-10" />
            <Route path="/services/workers-comp" element={<WorkersComp data-id="element-13" />} data-id="element-12" />

            {/* Insurance Types */}
            <Route path="/insurance/medicare" element={<Medicare data-id="element-15" />} data-id="element-14" />
            <Route path="/insurance/health" element={<IndividualFamilyHealth data-id="element-17" />} data-id="element-16" />
            <Route path="/insurance/life" element={<LifeInsurance data-id="element-19" />} data-id="element-18" />
            <Route path="/insurance/dental-vision" element={<DentalVision data-id="element-21" />} data-id="element-20" />
            <Route path="/insurance/disability" element={<Disability data-id="element-23" />} data-id="element-22" />
            <Route path="/insurance/travel" element={<TravelMedical data-id="element-25" />} data-id="element-24" />
            <Route path="/insurance/employer-group" element={<EmployerGroup data-id="element-27" />} data-id="element-26" />
          </Routes>
        </div>
        <Footer data-id="element-28" />
      </div>
    </Router>;
}